import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IReview, IReviewState } from './types';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';

const initialState: IReviewState = {
  addReview: {},
  reviews: {},
  searchUser: {},
  updateReview: {},
  reviewDetails: {},
};
const slice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    addReview(state, action: PayloadAction<IReview>) {
      state.addReview.status = RequestStatus.RUNNING;
    },
    addReviewSuccess(state, action: PayloadAction<IReview>) {
      state.addReview.status = RequestStatus.SUCCESS;
      state.addReview.data = action.payload;
    },
    addReviewFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addReview.status = RequestStatus.ERROR;
      state.addReview.error = action.payload;
    },
    //
    getReviews(state) {
      state.reviews.status = RequestStatus.RUNNING;
    },
    getReviewsSuccess(state, action: PayloadAction<IReviewState['reviews']['data']>) {
      state.reviews.status = RequestStatus.SUCCESS;
      state.reviews.data = action.payload;
    },
    getReviewsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.reviews.status = RequestStatus.ERROR;
      state.reviews.error = action.payload;
    },
    //
    searchUser(state, action: PayloadAction<string | undefined>) {
      state.searchUser.status = RequestStatus.RUNNING;
    },
    searchUserSuccess(state, action: PayloadAction<IReviewState['reviews']['data']>) {
      state.searchUser.status = RequestStatus.SUCCESS;
      state.searchUser.data = action.payload;
    },
    searchUserFailed(state, action: PayloadAction<IRequestFailed>) {
      state.searchUser.status = RequestStatus.ERROR;
      state.searchUser.error = action.payload;
    },
    //
    updateReview(state, action: PayloadAction<any>) {
      state.updateReview.status = RequestStatus.RUNNING;
    },
    updateReviewSuccess(state, action: PayloadAction<IReview>) {
      state.updateReview.status = RequestStatus.SUCCESS;
      state.updateReview.data = action.payload;
    },
    updateReviewFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateReview.status = RequestStatus.ERROR;
      state.updateReview.error = action.payload;
    },
    //
    getReviewDetails(state, action: PayloadAction<IReview>) {
      state.reviewDetails.status = RequestStatus.RUNNING;
    },
    getReviewDetailsSuccess(state, action: PayloadAction<IReviewState['reviewDetails']['data']>) {
      state.reviewDetails.status = RequestStatus.SUCCESS;
      state.reviewDetails.data = action.payload;
    },
    getReviewDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.reviewDetails.status = RequestStatus.ERROR;
      state.reviewDetails.error = action.payload;
    },
  },
});
export default slice.reducer;
export const {
  addReview,
  addReviewFailed,
  addReviewSuccess,
  getReviews,
  getReviewsFailed,
  getReviewsSuccess,
  searchUser,
  searchUserFailed,
  searchUserSuccess,
  updateReview,
  updateReviewFailed,
  updateReviewSuccess,
  getReviewDetails,
  getReviewDetailsFailed,
  getReviewDetailsSuccess,
} = slice.actions;
